import {Component, OnDestroy, OnInit} from '@angular/core';
import * as fromStore from '../../store';
import {Observable, Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import * as fromFeature from '../../my-features';
import {UsersState} from '../../store/reducers/user.reducers';
import {UserService} from '../../services/user.service';
import {CryptoService} from '../../services/crypto.service';

@Component({
  standalone: false,
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit, OnDestroy {
  purchaseHistory_cols: any[] = [
    { field: 'DeviceName', header: 'Node Name', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'Model', header: 'Model Name', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'NewLevel', header: 'Level', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'PeriodExtend', header: 'Period Extend', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'PreviousExpiredDate', header: 'Previous Expired Date', width: '180', class: 'col-nowrap', disabled: false },
    { field: 'NewExpiredDate', header: 'New Expired Date', width: '180', class: 'col-nowrap', disabled: false },
    { field: 'AmountPaid', header: 'Amount Paid', width: '170', class: 'col-nowrap', disabled: false },
    { field: 'Model', header: 'Model', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'Model', header: 'Model', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'Model', header: 'Model', width: '150', class: 'col-nowrap', disabled: false },
  ];
  orderNo: string;
  createDate = 0;
  status: string;
  totalAmountPaid: number;
  user$: Observable<UsersState>;
  purchaseHistory: any;
  currencyCode: string;
  private purchaseOrderDetail$: Subscription;
  constructor(private userService: UserService,
    private store: Store<fromStore.State>,
    private route: ActivatedRoute,
    private cryptoService: CryptoService) {
    this.user$ = this.store.pipe(select(fromStore.getCurrentUser));
  }

  ngOnInit() {
    this.UI();
    // this.purchaseHistory = [
    //   {
    //     nodeName: '1082938092',
    //     modelName: 'Completed',
    //     level: 'Level 1',
    //     periodExtend: '1 Year',
    //     previousExpiredDate: '2019/03/20',
    //     newExpiredDate: '2019/03/20',
    //     amountPaid: '8'
    //   },
    //   {
    //     nodeName: '1082938022',
    //     modelName: 'Completed',
    //     level: 'Level 1',
    //     periodExtend: '1 Year',
    //     previousExpiredDate: '2019/03/20',
    //     newExpiredDate: '2019/03/20',
    //     amountPaid: '8'
    //   },
    //   {
    //     nodeName: '1082937952',
    //     modelName: 'Completed',
    //     level: 'Level 1',
    //     periodExtend: '1 Year',
    //     previousExpiredDate: '2019/03/20',
    //     newExpiredDate: '2019/03/20',
    //     amountPaid: '8'
    //   },
    // ];
    this.orderNo = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('orderno'));
    // this.purchaseOrderDetail$ = this.store.select(fromStore.getPurchaseDetail, this.orderNo).subscribe(res => {
    //   this.purchaseHistory = res.entities;
    //   this.totalAmountPaid = res.totalAmountPaid;
    //   this.createDate = res.CreateTime;
    //   this.status = res.Status;
    //   this.currencyCode = res.CurrencyCode;
    // });
  }

  ngOnDestroy(): void {
    this.purchaseOrderDetail$.unsubscribe();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    // body.classList.remove('layout-toggle');
    body.classList.remove('mobile-toggle');
  }
}
